import { render, staticRenderFns } from "./VanTrucking.vue?vue&type=template&id=8da726b0"
import script from "./VanTrucking.vue?vue&type=script&lang=js"
export * from "./VanTrucking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports